
    import {Vue, Component} from "vue-property-decorator";
    import basicInfo from "untils/basicInfo";

    @Component
    export default class ContactUsView extends Vue {
        mapUrl = require("assets/images/joinUs/map.png");
        basicInfo = basicInfo;
    }
